import "./Aboutus.css";
import React from "react";

function Aboutus() {
  return (
    <div className="about-container">
      <h1>Our History</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti
        suscipit culpa assumenda illo autem officiis quasi natus, architecto
        labore nemo delectus ipsam nisi reiciendis est sunt earum amet veniam
        aliquid id expedita magni recusandae sit perspiciatis excepturi.
        Exercitationem qui molestiae recusandae aspernatur, temporibus hic,
        dicta corrupti provident maxime magnam amet.
      </p>
      <h1>Our Mission</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti
        suscipit culpa assumenda illo autem officiis quasi natus, architecto
        labore nemo delectus ipsam nisi reiciendis est sunt earum amet veniam
        aliquid id expedita magni recusandae sit perspiciatis excepturi.
        Exercitationem qui molestiae recusandae aspernatur, temporibus hic,
        dicta corrupti provident maxime magnam amet.
      </p>
      <h1>Our Vision</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Corrupti
        suscipit culpa assumenda illo autem officiis quasi natus, architecto
        labore nemo delectus ipsam nisi reiciendis est sunt earum amet veniam .
      </p>
    </div>
  );
}

export default Aboutus;
